import Penghasilan from './Penghasilan.vue'

export default Penghasilan
